import { Component, OnInit } from '@angular/core';
import {
  getNspProductsInPack,
  getNspProductsInPackPending,
  getNspProductsInPackTechnicalError,
  getNspStandaloneProducts,
  getNspStandaloneProductsPending,
  getNspStandaloneTechnicalError,
} from '../../store/reducers';
import { Product } from '@dch/products-business-logic';
import { getPiiNsp } from '../../shared/pii/pii.utils';
import {
  GetNspProductsInPack,
  GetNspStandaloneProducts,
} from '../store/actions/nsp.actions';
import { OnDestroyHookDirective } from '../../shared/hooks';
import { Store } from '@ngrx/store';
import { Router } from '@angular/router';
import { InceptionService } from '@proximus/ng-common';
import { ModalService } from '@proximus/ng-common-components';
import { NspBasketModalComponent } from '../nsp-basket-modal/nsp-basket-modal.component';
import { getNspMobileProducts } from '../utils/nsp.utils';

@Component({
  selector: 'mprd-nsp-activation-mobile-container',
  templateUrl: './nsp-activation-mobile-container.component.html',
})
export class NspActivationMobileContainerComponent
  extends OnDestroyHookDirective
  implements OnInit
{
  products: Product[];
  mobileProducts: Product[];
  productsLoaded = false;
  pending = false;
  error = false;
  subtitleKey: string;
  isStandalone = false;
  hasChanged = false;

  constructor(
    private router: Router,
    private store: Store,
    private inceptionService: InceptionService,
    private modalService: ModalService,
  ) {
    super();
  }

  ngOnInit() {
    this.addSubscription(
      this.store.select(getNspProductsInPack).subscribe((products) => {
        this.products = products;
        this.mobileProducts = getNspMobileProducts(products);
        this.productsLoaded = products && products.length > 0;
      }),
    );
    this.addSubscription(
      this.store.select(getNspProductsInPackPending).subscribe((pending) => {
        this.pending = pending;
      }),
    );
    this.addSubscription(
      this.store
        .select(getNspProductsInPackTechnicalError)
        .subscribe((error) => {
          this.error = !!error;
        }),
    );
    this.addSubscription(
      this.store.select(getNspStandaloneProducts).subscribe((products) => {
        this.products = products;
        this.mobileProducts = getNspMobileProducts(products);
        this.productsLoaded = products && products.length > 0;
      }),
    );
    this.addSubscription(
      this.store
        .select(getNspStandaloneProductsPending)
        .subscribe((pending) => {
          this.pending = pending;
        }),
    );
    this.addSubscription(
      this.store.select(getNspStandaloneTechnicalError).subscribe((error) => {
        this.error = !!error;
      }),
    );

    const { packId, plcList } = getPiiNsp();
    if (packId) {
      this.isStandalone = false;
      this.subtitleKey = 'nsp.activationMobile.subtitle';
      this.store.dispatch(new GetNspProductsInPack({ packId }));
    } else if (plcList) {
      this.isStandalone = true;
      this.subtitleKey = 'nsp.activationMobile.standalone.subtitle';
      this.store.dispatch(new GetNspStandaloneProducts({ plcList }));
    } else {
      this.router.navigate(['/overview']);
    }

    this.scrollToTop();
    this.inceptionService.init();
  }

  scrollToTop(): void {
    setTimeout(() => {
      this.inceptionService.scrollToElement('#nspActivationMobileContainer');
    });
  }

  continueToActivate(): void {
    this.modalService
      .create<NspBasketModalComponent>(NspBasketModalComponent)
      .subscribe((componentRef) => {
        componentRef.instance.isStandalone = this.isStandalone;
        componentRef.instance.isActivationFlow = true;
        componentRef.instance.products = this.products;
      });
  }

  handleHasChanged(hasChanged) {
    this.hasChanged = hasChanged;
  }
}
